import styled from 'styled-components'

export const Title = styled.h1`
    text-align: center;
    color: ${(props) => {return props.theme.colorPrimary}};
    font-weight: 700;
    font-size: 60px;
    line-height: 58px;
    max-width: 832px;
    margin: 20px;
`
